import MessageActionTypes from "Containers/Messages/types"
import { v4 as uuid } from "uuid"
import { isMessageAlreadyInList } from "./Messages.utils"

const INITIAL_STATE = {
  successMessage: "",
  warningMessage: "",
  errorMessage: "",
  infoMessage: "",
  successCode: "",
  warningCode: "",
  errorCode: "",
  infoCode: "",
  messageList: [],
}

const messageReducer = (state = INITIAL_STATE, { type, payload }) => {
  switch (type) {
    case MessageActionTypes.REMOVE_MESSAGE_FROM_LIST:
      var newMessageList = [...state.messageList]
      var indexToRemove = newMessageList.findIndex(messageElt => messageElt.messageId === payload)
      if (indexToRemove !== -1) newMessageList.splice(indexToRemove, 1)

      return {
        ...state,
        messageList: newMessageList,
      }

    // Remove Messages
    case MessageActionTypes.REMOVE_SUCCESS_MESSAGE:
      return {
        ...state,
        successMessage: "",
        successCode: "",
      }
    // Set success Code
    case MessageActionTypes.SET_SUCCESS_CODE:
      return {
        ...state,
        successCode: payload,
      }
    case MessageActionTypes.REMOVE_WARNING_MESSAGE:
      return {
        ...state,
        warningMessage: "",
        warningCode: "",
      }
    case MessageActionTypes.REMOVE_ERROR_MESSAGE:
      return {
        ...state,
        errorMessage: "",
        errorCode: "",
      }
    case MessageActionTypes.REMOVE_INFO_MESSAGE:
      return {
        ...state,
        infoMessage: "",
        infoCode: "",
      }
    // Set Messages
    case MessageActionTypes.SET_SUCCESS_MESSAGE:
      return {
        ...state,
        successMessage: payload.message,
        successCode: payload?.code,
        messageList: isMessageAlreadyInList([...state.messageList], payload?.code)
          ? [...state.messageList]
          : [
              ...state.messageList,
              {
                messageId: uuid(),
                code: payload?.code,
                message: payload.message,
                type: "success",
              },
            ],
      }
    case MessageActionTypes.SET_WARNING_MESSAGE:
      return {
        ...state,
        warningMessage: payload.message,
        warningCode: payload?.code,
        messageList: isMessageAlreadyInList([...state.messageList], payload?.code)
          ? [...state.messageList]
          : [
              ...state.messageList,
              {
                messageId: uuid(),
                code: payload?.code,
                message: payload.message,
                type: "warning",
              },
            ],
      }
    case MessageActionTypes.SET_ERROR_MESSAGE:
      return {
        ...state,
        errorMessage: payload.message,
        errorCode: payload?.code,
        messageList: isMessageAlreadyInList([...state.messageList], payload?.code)
          ? [...state.messageList]
          : [
              ...state.messageList,
              {
                messageId: uuid(),
                code: payload?.code,
                message: payload.message,
                type: "error",
              },
            ],
      }
    case MessageActionTypes.SET_INFO_MESSAGE:
      return {
        ...state,
        infoMessage: payload.message,
        infoCode: payload?.code,
        messageList: isMessageAlreadyInList([...state.messageList], payload?.code)
          ? [...state.messageList]
          : [
              ...state.messageList,
              {
                messageId: uuid(),
                code: payload?.code,
                message: payload.message,
                type: "info",
              },
            ],
      }
    default:
      return state
  }
}

export default messageReducer
